export default __webpack_public_path__ + "static/media/smilies01.50b6eee6.png";